import script from "./LoginErrorForRestartAccount.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginErrorForRestartAccount.vue?vue&type=script&lang=ts&setup=true"

import "./LoginErrorForRestartAccount.vue?vue&type=style&index=0&id=55eb8f40&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55eb8f40"]])

export default __exports__